import { Instagram, Linkedin, Phone, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="pt-20 pb-10"
      style={{ backgroundColor: "#EAE7E0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[rgba(28,28,28,0.12)]">
          <div className="md:col-span-6">
            <img
              src="https://customer-assets.emergentagent.com/job_kit-memoria/artifacts/j1su7rjr_MetierCom_Logo150x34.png"
              alt="MetierCom"
              className="h-10 md:h-12 w-auto"
              data-testid="metiercom-logo-footer"
            />
            <p className="font-serif text-3xl md:text-4xl mt-6 leading-tight text-[#1C1C1C] max-w-md">
              Brindes que viram <em className="italic text-[#556052]">experiência</em>.
            </p>
            <p className="mt-4 text-sm text-[#556052] max-w-md font-light">
              Grupo de comunicação que reúne <strong className="font-medium text-[#1C1C1C]">Remind Brindes</strong> e{" "}
              <strong className="font-medium text-[#1C1C1C]">Prestigiare Brindes</strong> — duas
              décadas transformando programas em momentos memoráveis.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Navegação</p>
            <ul className="space-y-3 text-sm text-[#1C1C1C]">
              <li><a href="#diferenciais" className="link-underline">Diferenciais</a></li>
              <li><a href="#processo" className="link-underline">Processo</a></li>
              <li><a href="#cases" className="link-underline">Cases</a></li>
              <li><a href="#depoimentos" className="link-underline">Depoimentos</a></li>
              <li><a href="#grupo" className="link-underline">Grupo MetierCom</a></li>
              <li><a href="#contato" className="link-underline">Contato</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Contato MetierCom</p>
            <ul className="space-y-3 text-sm text-[#1C1C1C]">
              <li className="flex items-start gap-2">
                <Phone size={14} strokeWidth={1.5} className="mt-1 text-[#C5A059]" />
                <a
                  href="https://wa.me/5511972053030"
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline"
                  data-testid="footer-whatsapp-link"
                >
                  (11) 97205-3030 · WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Globe size={14} strokeWidth={1.5} className="mt-1 text-[#C5A059]" />
                <a
                  href="https://www.metiercom.com.br"
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline"
                  data-testid="footer-website-link"
                >
                  www.metiercom.com.br
                </a>
              </li>
              <li className="text-[#556052]">São Paulo · Brasil</li>
              <li className="text-[#556052]">Atendimento nacional</li>
            </ul>
            <div className="mt-6 flex gap-4">
              <a href="#" data-testid="social-instagram" aria-label="Instagram" className="text-[#1C1C1C] hover:text-[#C5A059] transition-colors">
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a href="#" data-testid="social-linkedin" aria-label="LinkedIn" className="text-[#1C1C1C] hover:text-[#C5A059] transition-colors">
                <Linkedin size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#556052]">© {new Date().getFullYear()} MetierCom. Todos os direitos reservados.</p>
          <p className="text-xs text-[#556052]">Remind Brindes · Prestigiare Brindes · Atendimento nacional</p>
        </div>
      </div>
    </footer>
  );
}
